// extracted by mini-css-extract-plugin
module.exports = {"container":"Copyright-module--container--sPHE5","text":"Copyright-module--text--2NaSY"};